export default __webpack_public_path__ + "static/media/standOutBtn.dc8057b1.png";